import { useCallback, useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useAuth } from '../features/Auth';
import addressBooksSlice from '../redux/addressBooksSlice';
import { PAGINATIONS, STRINGS } from '../constants';
import useErrorHandler from './useErrorHandler';

const useInitializeAddressBooks = (
  searchPageSize = PAGINATIONS.DEFAULT_SEARCH_MODAL_SIZE
) => {
  const {
    currentSession: { uid },
  } = useAuth();
  const { errorHandler } = useErrorHandler();
  const [totalPages, setTotalPages] = useState(1);
  const dispatch = useDispatch();

  const fetchAddressBooks = useCallback(async () => {
    if (uid) {
      try {
        const data = await dispatch(
          addressBooksSlice.actions.fetchAddressBooks({
            searchPage: 1,
            searchPageSize,
          })
        ).unwrap();

        setTotalPages(data?.totalPages || 0);
      } catch (error) {
        errorHandler({
          message: STRINGS.ADDRESSES_SECTION.NOTIFICATIONS.ERROR.FETCHING_ERROR,
          error,
        });
      }
    }
  }, [dispatch, uid]);

  useEffect(() => {
    fetchAddressBooks();
  }, [fetchAddressBooks]);

  return totalPages;
};

export default useInitializeAddressBooks;
